import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { FormField, FormSheet, Input } from '@/shared/components';
import type { PropertyGroupResponse } from '@/shared/api';
import {
  stayTimesDefaults,
  stayTimesPatch,
  stayTimesSchema,
  type StayTimesValues,
} from './objectEditForms';
import { useObjectUpdate } from './useObjectUpdate';

/** Check-in und Check-out des Objekts — Haustürcode und Hausordnung bleiben unberührt. */
export function ObjectStayTimesSheet({
  group,
  onClose,
}: {
  group: PropertyGroupResponse;
  onClose: () => void;
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm<StayTimesValues>({
    resolver: zodResolver(stayTimesSchema),
    defaultValues: stayTimesDefaults(group),
  });
  const { save, saving, error } = useObjectUpdate(
    group,
    '/property-groups/$id/stammdaten',
    onClose,
  );

  return (
    <FormSheet
      title="Check-in & Check-out"
      description="Gilt für alle Apartments dieses Objekts. Reinigungsfenster, Gastportal und Anfahrt rechnen mit diesen Zeiten."
      dirty={isDirty}
      saving={saving}
      canSave={isDirty}
      error={error}
      onSubmit={handleSubmit((values) => save(stayTimesPatch(values)))}
      onClose={onClose}
    >
      <div className="grid grid-cols-2 gap-4">
        <FormField label="Check-in ab" error={errors.checkInTime?.message} required>
          <Input type="time" {...register('checkInTime')} />
        </FormField>
        <FormField label="Check-out bis" error={errors.checkOutTime?.message} required>
          <Input type="time" {...register('checkOutTime')} />
        </FormField>
      </div>
    </FormSheet>
  );
}
